import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class SnowflakeService {
  async getAccountData() {
    return (await fetchApi.get(`snowflake-account`)).data;
  }

  async addAccount(data, type) {
    return (await fetchApi.post(`snowflake-account/${type}`, data)).data;
  }

  async updatePassword(postData) {
    return (await fetchApi.post(`snowflake-account/update-password`, postData)).data;
  }

  async importWorkspace(postData) {
    return (await fetchApi.post(`/workspace/import`, postData)).data;
  }

  async upgradeWorkspace(postData) {
    return (await fetchApi.post(`/workspace/upgrade`, postData)).data;
  }

  async getImportList() {
    return (await fetchApi.get(`/workspace/importlist`)).data;
  }

  async getClusterList() {
    return (await fetchApi.get(`snowflake-account/clusterlist`)).data;
  }

  async getTables(Workspace_id, schema) {
    const response = await fetchApi.get(`/workspace/${Workspace_id}/quickimport/snowflake/${schema}`);
    if (
      response.status === 401 ||
      response.statusText === "Unauthorized" ||
      (response.data.errorType && response.data.errorType === "credentials")
    )
      return "Unauthorized";

    return response.data;
  }

  async getUsageReport() {
    return (await fetchApi.get(`snowflake-account/usage-report`)).data;
  }

  async resetMFA(postData) {
    return (await fetchApi.post(`snowflake-account/reset-mfa`, postData)).data;
  }

  async resetPrivateKey({ publicKey }) {
    return (await fetchApi.post(`snowflake-account/reset-key`, { publicKey })).data;
  }

  async deleteAPIUser() {
    return (await fetchApi.delete(`snowflake-account/user`)).data;
  }

  async createAPIUser({ publicKey }) {
    return (await fetchApi.post(`snowflake-account/create-api-user`, { publicKey })).data;
  }
}
